import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPermissionsModule } from 'ngx-permissions';
import { iccIconEmail, IconRegistryService, UiModule } from '@icc/ui';
import { CdkTreeModule } from '@angular/cdk/tree';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '@icc/shared';
import { B2BSharedModule } from 'libs/b2b/shared/src/lib/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { B2bSalesDocumentModule } from '@icc/b2b/sales-document';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { ComplaintsV1ListComponent } from './complaints-v1-list/complaints-v1-list.component';
import { ComplaintV1Component } from './complaint-v1/complaint-v1.component';
import { ComplaintV1FiltersComponent } from './complaint-v1-filters/complaint-v1-filters.component';
import { ComplaintV1StatusComponent } from './complaint-v1-status/complaint-v1-status.component';
import { ComplaintV1HistoryComponent } from './complaint-v1-history/complaint-v1-history.component';

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        UiModule,
        CdkTreeModule,
        HttpClientModule,
        NgxPaginationModule,
        SharedModule,
        B2BSharedModule,
        TranslateModule,
        B2bSalesDocumentModule,
        FormsModule,
        ReactiveFormsModule,
        A11yModule,
    ],
    declarations: [
        ComplaintsV1ListComponent,
        ComplaintV1Component,
        ComplaintV1FiltersComponent,
        ComplaintV1StatusComponent,
        ComplaintV1HistoryComponent,
    ],
})
export class B2bComplaintsV1Module {
    constructor(private iconRegistry: IconRegistryService) {
        this.iconRegistry.registerIcons([
            iccIconEmail,
        ]);
    }
}
